export const addAlpha = (color, opacity) => {
    const finalOpacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
    return color + finalOpacity.toString(16).toUpperCase();
};

export const hex2rgba = (hex = '#FFFFFF', alpha = 100) => {
    const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgba(${r},${g},${b},${alpha / 100})`;
};
